<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <g ref="image" :transform-origin="`${canvasWidth/2} ${canvasHeight/2}`" clip-path="url(#clip-frame)">
        <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
          <picture>
            <source :srcset="`${publicPath}scenes/bucket/Bucket1-480w.jpg`" media="(max-width: 480px)">
            <source :srcset="`${publicPath}scenes/bucket/Bucket1-768w.jpg`" media="(max-width: 768px)">
            <source :srcset="`${publicPath}scenes/bucket/Bucket1-1280w.jpg`" media="(max-width: 1280px)">
            <source :srcset="`${publicPath}scenes/bucket/Bucket1-1920w.jpg`" media="(max-width: 1920px)">
            <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/bucket/Bucket1.jpg`" />
          </picture>
        </foreignObject>
      </g>
    </svg>
    <SceneDialogue
      ref="dialogue"
      :width="0.9"
      :fontSize="20"
      :styles="{padding: `1.25em`, lineHeight: `1.33em`}"
      :tx="0.5" :ty="0.5">
      <h1 class='minion bold header' style='margin: 0.5em auto 0.75em 0'>Foreword</h1>
      The life of my Grandfather, Max Littlesalt, has intrigued me my entire
      life. His life spanned nine decades and in those decades, what a life he
      led.<br><br>
      He had great courage to leave the Navajo Reservation as a young man, to
      seek higher education in “a white man’s world.” Upon his return to the
      Reservation, he dedicated his life as a civil servant to his community.
      This graphic biography is based on stories told by my Uncle, Charlie
      Littlesalt, who is Max’s son.<br><br>
      The graphic biography idea was formed at The ONWARD Project’s first
      conference five years ago. The attendees at the conference were divided
      into small groups. In one of those groups my mother, Louise, came up
      with the idea of a comic book to tell Max’s story.<br><br>
      Therefore it is my honor to write this foreword. I was introduced to Sam
      and Shea at an event for The ONWARD Project. As summer interns, they
      were selected to illustrate and write the graphic biography. Shea and
      Sam interviewed Charlie and me at the Naatsis’áán Ééhániih Navajo
      Mountain Pioneer Day Celebration and showed me their storyboard. I was
      very impressed with their focus, ideas, organization and drive.<br><br>
      <div class='minion italic text-right' style='font-size: 1.25em; margin: 0 0.25em 0.5em 0;'>&mdash; Lithuania Denetso</div>
    </SceneDialogue>
  </div>
</template>

<script>
import SceneDialogue from "../SceneDialogue.vue"
import Template from "./Template"
import {TimelineLite, TweenLite} from "gsap"

export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    canvasWidth: 4175,
    canvasHeight: 3006,
    contentPadding: 20,
    dy: 0,
    showContent: false,
    tl: null,
  }),
  props: ["slide"],
  extends: Template,
  mounted() {
    const d = this.$refs["dialogue"].$el
    // this.tl = new TimelineLite({paused: true})
    TweenLite.set(this.$refs["scene"], {opacity: 0})
    TweenLite.set(d, {opacity: 0})
    this.tl.add(TweenLite.to(this.$refs["scene"], 1, {opacity: 1}))
    this.tl.add(TweenLite.to(d, 0.5, {opacity: 1}))
  },
  methods: {
    enter() {this.tl.play()},
    exit() {console.log("exit from base")},
  },
  components: {
    SceneDialogue,
  },
}
</script>

<style lang="scss">
</style>
